import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class LoadingService {
    public isLoading: BehaviorSubject<boolean>;

    constructor() {
        this.isLoading = new BehaviorSubject<boolean>(false);
    }

    public setIsLoading(val: boolean): void {
        this.isLoading.next(val);
    }

    public getIsLoading(): Observable<boolean> {
        return this.isLoading;
    }
}
